<div class="space-y-4">
  @for (item of (menuItems$ | async) ?? []; track item.label) {
    <a
      [routerLink]="item['route']"
      class="flex items-center cursor-pointer transition-all duration-300 mx-[10px] rounded-xl relative group p-2 justify-center"
      [ngClass]="{
        'bg-blue-800 text-white': item['active'],
        'text-bluegray-400 hover:text-white hover:bg-blue-800/50':
          !item['active'],
      }"
      [pTooltip]="isCollapsed() ? item.label : ''"
      tooltipPosition="right"
      [showDelay]="300"
      [hideDelay]="0"
    >
      @if (item.icon) {
        <i
          [class]="item.icon"
          class="!text-[24px] flex-shrink-0"
          [ngClass]="{
            'text-white': item['active'],
            'text-bluegray-400 group-hover:text-white': !item['active'],
          }"
        ></i>
      }

      <!-- Label com transição suave -->
      <span
        class="font-medium transition-all duration-300 overflow-hidden whitespace-nowrap"
        [ngClass]="{
          'text-white': item['active'],
          'text-bluegray-400 group-hover:text-white': !item['active'],
          'w-0 opacity-0 ml-0': isCollapsed(),
          'w-auto opacity-100 ml-3': !isCollapsed(),
        }"
      >
        {{ item.label }}
      </span>

      <!-- Indicador ativo -->
      @if (item['active'] && !isCollapsed()) {
        <div
          class="absolute left-[-12px] top-1/2 -translate-y-1/2 w-1 h-6 bg-blue-500 rounded-r-full shadow-[0_0_8px_rgba(59,130,246,0.5)]"
        ></div>
      }
    </a>
  }
</div>
